import { useLoaderData } from "@remix-run/react";
import { privacyPolicyLoader, privacyPolicyMeta } from "framework/routes/index";
import { PrivacyPolicyPageContent } from "~/modules/informative-pages/pages";

export const loader = privacyPolicyLoader;
export const meta = privacyPolicyMeta;

export default function PrivacyPolicy() {
  const data = useLoaderData<any>();

  return <PrivacyPolicyPageContent page={data} />;
}
